export * from './UserStore'
export {CurrentUserStore} from './CurrentUserStore'

export type CentricUserName = string


// WEBPACK FOOTER //
// ./src/stores/user/index.ts